import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import { VpIcon } from '../../';

export const VpInfoMenuItem = ({ item, onSelect, optionalLabelValue = 'label', ...rest }) => {
  const onItemSelect = (e) => {
    onSelect && onSelect(e, item);
  };

  const styles =
    item?.variant === 'error'
      ? {
          color: 'vpColors.redMain'
        }
      : {};

  return (
    <MenuItem key={item.id} onClick={onItemSelect} {...rest}>
      {item?.icon && (
        <ListItemIcon>
          <VpIcon sx={styles} icon={item?.icon} />
        </ListItemIcon>
      )}
      <ListItemText primaryTypographyProps={{ sx: styles }}>
        {item[optionalLabelValue]}
      </ListItemText>
    </MenuItem>
  );
};

VpInfoMenuItem.propTypes = {
  item: PropTypes.object,
  onSelect: PropTypes.func,
  optionalLabelValue: PropTypes.string
};

export default VpInfoMenuItem;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpInfoMenu/VpInfoMenuItem.jsx